/* eslint-disable camelcase */
/**
 * Track adding, updating, and removing of cart items for Monetate pixel
 * @param {Object} updatedCartData - updated cart data (sku, quantity, price, etc)
 * @returns void
 */
function trackCartUpdates ({
	order_currency_code, product_sku, product_category, product_quantity, product_price
}) {

	const cartRows = [];

	if (product_sku.length > 0) {

		product_sku.forEach((sku, i) => {

			cartRows.push({
				currency: order_currency_code || 'USD',
				productId: sku,
				sku,
				quantity: product_quantity[i],
				unitPrice: product_price[i],
				product_category: product_category[i]
			});

		});

		window.monetateQ = window.monetateQ || [];
		window.monetateQ.push([ 'setPageType', window.utag_data.page_type ]);
		window.monetateQ.push([ 'addCategories', product_category ]);
		window.monetateQ.push([ 'addCartRows', cartRows ]);
		window.monetateQ.push([ 'trackData' ]);

	} else {

		// Indicate an empty cart
		// Explicitly set page_type to "cart" because utag_data.page_type is set to 'all' for empty cart
		window.monetateQ = window.monetateQ || [];
		window.monetateQ.push(['setPageType', 'cart']);
		window.monetateQ.push([ 'addCartRows', [] ]);
		window.monetateQ.push([ 'trackData' ]);

	}

}

export default trackCartUpdates;
